<template>
  <div>
    <div class="arena">
      <div class="slide">
        <mySlide />
      </div>
      <div>
        <div class="csgo-title" style="margin-bottom: 24px;">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t p-1">免费ROLL房饰品</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="new-csgo-table">
          <div class="flex flex-ac w1500">
            <div class="table-item" :class="{'table-active':activeName=='first'}" @click="handleClick('first')">进行中的ROLL房间</div>
            <div class="table-item" :class="{'table-active':activeName=='third'}" @click="handleClick('third')">历史记录</div>
            <div class="table-item" :class="{'table-active':activeName=='second'}" @click="handleClick('second')">我参与的</div>
          </div>
        </div>
      </div>
      <div class="arena-warp w1500">
        <div>
          <div class="list-box flex flex-w">
            <div v-for="(item,index) in list" :key="item.id" class="li" @click="jionRoom(item.id)">
              <div class="list-warp">
                <div class="tou">
                  <div class="flex flex-ac">
                    <img :src="item.img" />
                    <div class="type flex-0">{{ item.type==1?'官方':'主播' }}</div>
                    <div class="name p-1">{{ item.room_name }}</div>
                  </div>
                </div>
                <swiper>
                  <swiper-slide v-for="(item1, index1) in item.skin_list" :pagination="{ clickable: true }" :key="index1" class="swiper-slide">
                    <div class="swiper-item" :class="parseColor(item1)">
                      <div class="flex-jc flex flex-ac swiper-item-i-b">
                        <div v-if="item.subclassName" class="subclassName">{{ item1.subclassName }}</div>
                        <img :src="item1.imageUrl" class="">
                      </div>
                      <div class="dot flex-ac flex-jc flex">
                        <div v-for="(s,si) in item.skin_list" :key="si" class="dot-point" :class="{'dot-active':si==index1}"></div>
                      </div>
                      <!-- subclassName -->
                      <div class="item1-name p-1">{{ item1.shortName }}</div>
                      <div class="flex flex-jsb">
                        <div class="sort">{{ item1.exteriorName }}</div>
                        <div class="price flex flex-ac">
                          <img src="@/assets/images/money.png" class="money-img" />
                          <span>{{ item1.price }}</span>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="num flex flex-jsb flex-ac">
                  <div class="flex flex-ac">
                    <div class="people-icon flex-0 flex flex-ac">
                      <div class="icon flex-0 flex flex-ac flex-jc"><i class="el-icon-user-solid"></i></div>
                      <span class="num6">{{ item.person_num }}</span>
                    </div>
                    <div class="num-box">
                      <span>总数量</span>
                      <span class="n">{{ item.count }}</span>
                    </div>
                  </div>
                  <div class="num-box">
                    <span class="num-span flex flex-ac">
                      <img src="@/assets/images/money.png" class="money-img" />
                      <span>{{ item.pool }}</span>
                    </span>
                  </div>
                </div>
                <div v-if="item.status==2" class="time">开奖时间 : {{ item.run_lottery_time }}</div>
                <countdown class="countdown-box" v-else :end-time="item.run_lottery_time" @countdown-ended="getNewEndTime">
                </countdown>
                <div class="btn">
                  <div v-if="item.status==2" class="btn-w-r-bg btn-blue">
                    <div class="btn-c-r">查看详情</div>
                  </div>
                  <div v-else-if="activeName=='first'" class="btn-w-r-bg">
                    <div class="btn-c-r">加入房间</div>
                  </div>
                  <div v-else class="btn-w-r-bg btn-blue">
                    <div class="btn-c-r">查看详情</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="list.length>0" class="csgo-page">
            <el-pagination background :pager-count="5" layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
        <div v-if="list.length===0" class="no-data">
          <img src="@/assets/images/roll/no-data.png" alt="" srcset="">
          <div class="text">暂无任何数据哦~</div>
        </div>
      </div>
      <div class="about">
        <div class="csgo-title">
          <div class="flex flex-ac flex-jc">
            <img src="@/assets/images/title-label.png" />
            <div class="t">关于ROLL房</div>
            <img src="@/assets/images/title-label.png" />
          </div>
        </div>
        <div class="w1500">
          <div class="info">
            <div style="overflow: hidden;" :class="{'height40':!showMore}">
              <div v-html="boxInfo.content" class="html-box"></div>
            </div>
            <div class="show-btn flex flex-ac" @click="showMore=!showMore">{{ showMore?'收起':'展开' }}<i :class="[showMore?'el-icon-arrow-up':'el-icon-arrow-down']"></i></div>
          </div>
        </div>
      </div>
      <myhomebot></myhomebot>
    </div>
    <div class="commonBg"></div>
  </div>

</template>
<script>
import myhomebot from "@/components/my_homebot.vue";
import countdown from "@/g-components/countdown.vue";
import mySlide from "@/g-components/my_slide.vue";
import { parseColor } from "@/assets/js/util.js";

export default {
  components: { myhomebot, countdown, mySlide },
  data() {
    return {
      parseColor,
      activeName: "first",
      list: [],
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 20,
        status: 1
      },
      boxInfo: {
        name: '',
        content: ''
      },
      showMore: false
    };
  },
  created() {
    this.getData()
    this.getList()
  },
  methods: {
    getData() {
      this.$doGet("/api/setting.Accord/info", {
        accord_id: 'Roll'
      }).then((res) => {
        this.boxInfo = res.data
      }).catch(() => { })
    },
    getNewEndTime() {
      this.getList()
    },
    handleClick(e) {
      if (e == this.activeName) {
        return false
      }
      this.activeName = e
      if (e == 'first') {
        this.searchForm.status = 1
      }
      if (e == 'third') {
        this.searchForm.status = 2
      }
      this.list = []
      this.searchForm.page = 1
      if (this.activeName == 'second') {
        if (!this.$store.state.loginState) {
          this.$store.commit("getLogin", true);
          return;
        }
      }
      this.getList();
    },
    //分页 所有记录
    currentChange(value) {
      this.searchForm.page = value
      this.getList();
    },
    //免费饰品房间列表
    getList() {
      this.$doGet(this.activeName == 'second' ? '/api/hall.Roll/myFreeRoomList' : "/api/hall.Roll/list", this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
      }).catch(() => { })
    },
    //加入房间
    jionRoom(id) {
      this.$router.push({
        path: `/roll/room`,
        query: {
          id: id,
        },
      });
    },
  }
};
</script>

<style lang="less" scoped>
.arena {
  min-height: 100vh;
  .slide {
    margin-bottom: 60px;
  }
  .arena-warp {
    padding-top: 24px;
    .list-box {
      .li {
        width: 25%;
        padding: 12px 15px;
        box-sizing: border-box;
        .list-warp {
          padding: 20px;
          border-radius: 8px;
          background-image: url('~@/assets/images/roll/roll-bg.png');
          background-size: 100% 100%;
          overflow: hidden;
          color: #fff;
          box-sizing: border-box;
          .tou {
            margin-bottom: 15px;
            font-size: 16px;
            img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }
            .name {
              font-family: ninefont;
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
            }
            .type {
              color: #ffc400;
              font-weight: 700;
              padding: 0 2px 0 8px;
            }
          }
          .time {
            line-height: 57px;
            text-align: center;
          }
          .countdown-box {
            padding: 10px 0 10px;
          }
          .swiper-item {
            width: 100%;
            // 原来的样式
            .swiper-item-y {
              width: 134px;
              height: 146px;
              margin: 0 auto;
              background-image: url('~@/assets/images/roll/img-bg.png');
              background-size: 100% 100%;
              position: relative;
              .subclassName {
                position: absolute;
                top: 11px;
                left: 11px;
                background-image: url('~@/assets/images/roll/img-3.png');
                background-size: 100% 100%;
                width: 63px;
                height: 19px;
                line-height: 19px;
                text-align: center;
                font-size: 12px;
                overflow: hidden;
                padding: 0 4px;
                box-sizing: border-box;
              }
              img {
                height: 90px;
                max-width: 80%;
              }
            }
            .swiper-item-i-b {
              max-width: 140px;
              aspect-ratio: 1 / 1;
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              .subclassName {
                position: absolute;
                top: 11px;
                left: 11px;
                background-image: url('~@/assets/images/roll/img-3.png');
                background-size: 100% 100%;
                width: 63px;
                height: 19px;
                line-height: 19px;
                text-align: center;
                font-size: 12px;
                overflow: hidden;
                padding: 0 4px;
                box-sizing: border-box;
              }
              img {
                height: 75%;
                width: auto;
              }
            }
            .dot {
              margin: 8px 0 12px;
              .dot-point {
                width: 4px;
                height: 4px;
                border-radius: 50%;
                margin: 0 2px;
                background-color: rgba(255, 255, 255, 0.4);
                &.dot-active {
                  background: #fff;
                }
              }
            }
            .item1-name {
              font-weight: bold;
              margin-bottom: 8px;
              padding-left: 2px;
            }
            .sort {
              font-size: 12px;
              height: 16px;
              color: #bbb9b9;
              margin-bottom: 9px;
            }
            .price {
              font-size: 12px;
              height: 16px;
              color: #ffc400;
              margin-bottom: 9px;
            }
            &.darkBlue-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/dark_blue.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.babyBlue-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/baby_blue.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.yellow-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/yellow.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.red-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/red.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.lavender-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/lavender.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.eggplant-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/eggplant.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            &.gray-skin {
              .swiper-item-i-b {
                background: url(~@/assets/images/skin/gray.png) no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .num {
            .num-box {
              line-height: 24px;
              span {
                color: #bbb9b9;
                font-size: 12px;
              }
              .n {
                border-radius: 22px;
                padding: 0 16px;
                line-height: 22px;
                border: 1px solid #bbb9b9;
                margin-left: 10px;
              }
              .num-span {
                font-weight: bold;
                font-size: 18px;
                color: #ffc400;
              }
            }
            .people-icon {
              .icon {
                width: 20px;
                height: 20px;
                background: #2b2e3c;
                border-radius: 50%;
                margin-right: 4px;
                font-size: 14px;
              }
              margin-right: 4px;
            }
          }
          .img {
            margin-top: 20px;
            .img-box {
              width: 30%;
              background-image: url('~@/assets/img/box-skins-blue.jpg');
              background-size: 100% 100%;
              position: relative;
              text-align: center;
              padding: 5px 0;
              // margin-right: 2px;

              img {
                width: auto;
                max-width: 90%;
                height: 45px;
              }
              span {
                position: absolute;
                top: 15px;
                left: 50%;
                margin-left: -25px;
                color: #fff;
                padding: 0 10px;
                border-radius: 20px;
                background-color: rgba(0, 0, 0, 0.3);
                font-size: 10px;
              }
            }
          }
          .btn {
            .btn-warp {
              width: 100%;
              padding: 3px 6px;
              border-radius: 8px 0 8px 0;
              background: rgba(101, 80, 6, 0.6);
              box-sizing: border-box;
              .b {
                cursor: pointer;
                border-radius: 8px 0 8px 0;
                background-color: #ffc400;
                line-height: 54px;
                text-align: center;
                font-size: 16px;
                color: #2b2e3c;
                font-weight: 600;
              }
              &.btn-warp-look {
                background-color: rgba(6, 91, 101, 0.6);
                .b {
                  background: #00f7ff;
                }
              }
            }
          }
        }
      }
    }
  }
  .about {
    background-color: #181c1f;
    box-sizing: border-box;
    padding-top: 30px;
    .info {
      box-sizing: border-box;
      border-radius: 8px;
      border: 2px solid #1c3c4d;
      margin: 32px auto 0;
      color: #fff;
      line-height: 26px;
      padding: 30px;
      .height40 {
        max-height: 400px;
      }
      .show-btn {
        padding: 30px 0 0;
        cursor: pointer;
      }
    }
  }
  .no-data {
    padding: 100px 0;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
    img {
      width: 182px;
      margin-bottom: 10px;
    }
  }
}
</style>
